/**
 * Nomadic Watches — Finance Widget JS
 * finance-widget.js
 */

(function () {
  'use strict';

  function initFinanceWidget(widget) {
    console.log("initFinanceWidget >>>>>>>>",widget.dataset);
    const minprice      = parseFloat(widget.dataset.minDeposit);
    const maxprice      = parseFloat(widget.dataset.maxDeposit);
    const price      = parseFloat(widget.dataset.price);
    const apr        = parseFloat(widget.dataset.apr);
    const ctaUrl     = widget.dataset.checkoutUrl;
    const variantId  = widget.dataset.variantId;
    const ctaText    = widget.dataset.cta;
    const termsStr   = widget.dataset.terms;
    const defaultTerm = parseInt(widget.dataset.defaultTerm, 10);

    // Parse available terms
    const availableTerms = termsStr.split(',').map(t => parseInt(t.trim(), 10)).filter(Boolean);

    let currentTerm    = availableTerms.includes(defaultTerm) ? defaultTerm : availableTerms[0];
    let currentDeposit = parseFloat(widget.querySelector('#fw-deposit-input').value) || 0;
    const depositInput   = widget.querySelector('#fw-deposit-input');
    const depositSlider  = widget.querySelector('#fw-deposit-slider');
    const depositBadge   = widget.querySelector('#fw-deposit-badge');
    const termsGrid      = widget.querySelector('#fw-terms-grid');
    const header         = widget.querySelector('.fw-header');
    const toggleBtn      = widget.querySelector('#fw-toggle');
    const body           = widget.querySelector('#fw-body');
    const ctaBtn         = widget.querySelector('#fw-cta-btn .btn-text');

    const elMonthly       = widget.querySelector('#fw-monthly');
    const elHeaderMonthly = widget.querySelector('#fw-header-monthly');
    const elFinanced      = widget.querySelector('#fw-financed');
    const elTotal         = widget.querySelector('#fw-total');

    const elRepCash      = widget.querySelector('#fw-rep-cash');
    const elRepTerm      = widget.querySelector('#fw-rep-term');
    const elRepDeposit   = widget.querySelector('#fw-rep-deposit');
    const elRepPayments  = widget.querySelector('#fw-rep-payments');
    const elRepCredit    = widget.querySelector('#fw-rep-credit');
    const elRepInterest  = widget.querySelector('#fw-rep-interest');
    const elRepApr       = widget.querySelector('#fw-rep-apr');
    const elRepTotal     = widget.querySelector('#fw-rep-total-payable');
    const addButton = document.querySelector('.product-form-wrapper .product-form__submit[name="add"]');
    // Set CTA text (supports runtime override)
    if (ctaBtn && ctaText) ctaBtn.textContent = ctaText;

    // ---- Finance Calculations ----
    // function calcMonthlyPayment(financed, apr, months) {
    //   if (financed <= 0) return 0;
    //   const monthlyRate = apr / 100 / 12;
    //   if (monthlyRate === 0) return financed / months;
    //   return (financed * monthlyRate * Math.pow(1 + monthlyRate, months)) /
    //          (Math.pow(1 + monthlyRate, months) - 1);
    // }

    const multipliers = {
      12: 1,
      24: 0.0475794,
      36: 0.0337325,
      48: 0.0268673,
      60: 0.0227941
    };

    function calcMonthlyPayment(financed, apr, months) {
      if (financed <= 0 || months <= 0) {
        return 0;
      }

      const multiplier = multipliers[months];
      widget.setAttribute("current-multiplier",multiplier)
      if (multiplier !== undefined) {
        if (multiplier === 1) {
          return ((financed / months) * 100) / 100;
        }
        return ((financed * multiplier) * 100) / 100;
      }
      const monthlyRate = apr / 100 / 12;
      let payment;

      if (monthlyRate === 0) {
        payment = financed / months;
      } else {
        payment = (financed * monthlyRate * Math.pow(1 + monthlyRate, months)) /
                  (Math.pow(1 + monthlyRate, months) - 1);
      }
      console.log("payment =",payment);
      return payment;
    }

    
    function fmt(n) {
      return '£' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function updateUI() {
      var currentMultiplier = widget.getAttribute("current-multiplier");
      const deposit  = Math.min(Math.max(currentDeposit, 0), price);
      const financed = price - deposit;
      var monthly  = calcMonthlyPayment(financed, apr, currentTerm);
      const decimals = monthly.toString().split('.')[1];

      console.log("monthly before = ",monthly);
      let compareWith = parseFloat(monthly.toFixed(2));
      if (decimals && decimals.length === 3) {
        monthly = compareWith - 0.01;
      }
      else if (monthly > compareWith) {
        monthly = compareWith + 0.01;
      } else {
        monthly = compareWith;
      }
      console.log("monthly after = ",monthly);
      const total    = monthly * currentTerm + deposit;

      // Deposit %
      var currentValue = parseInt(depositBadge.getAttribute("data-value"));
      
      const pct = price > 0 ? Math.round((deposit / price) * 100) : 0;
      //console.log("pct = ",pct);
      if(currentValue == pct){
        // return false;
      }

      if (depositBadge) depositBadge.textContent = pct + '%';
      depositBadge.setAttribute("data-value",pct);
      // Summary
      if (elMonthly)       elMonthly.textContent       = fmt(monthly);
      if (elHeaderMonthly) elHeaderMonthly.textContent  = fmt(monthly);
      if (elFinanced)      elFinanced.textContent       = fmt(financed);
      if(currentMultiplier == "1"){
        if (elTotal)         elTotal.textContent          = fmt(price);
      }else{
        if (elTotal)         elTotal.textContent          = fmt(total);
      }

      // Rep Example
      if (elRepCash)     elRepCash.textContent     = fmt(price);
      if (elRepTerm)     elRepTerm.textContent      = currentTerm + ' Months';
      if (elRepDeposit)  elRepDeposit.textContent   = fmt(deposit);
      if (elRepPayments) elRepPayments.textContent  = currentTerm + ' × ' + fmt(monthly);
      if(document.querySelector("button.fw-term-btn.fw-term-active").dataset.interest){
        if (elRepInterest) elRepInterest.textContent  = document.querySelector("button.fw-term-btn.fw-term-active").dataset.interest + '% P.A. Fixed';
        if (elRepCredit)   elRepCredit.textContent    = document.querySelector("button.fw-term-btn.fw-term-active").dataset.interest + '% P.A. Fixed';
        if (elRepApr)      elRepApr.textContent       = document.querySelector("button.fw-term-btn.fw-term-active").dataset.interest + '% APR';
      }else{
        if (elRepInterest) elRepInterest.textContent  = apr.toFixed(1) + '% P.A. Fixed';
        if (elRepCredit)   elRepCredit.textContent    = apr.toFixed(1) + '% P.A. Fixed';
        if (elRepApr)      elRepApr.textContent       = apr.toFixed(1) + '% APR';
      }
      
      
      if(currentMultiplier == "1"){
        if (elRepTotal)    elRepTotal.textContent     = fmt(price);
      }else{
        if (elRepTotal)    elRepTotal.textContent     = fmt(total);
      }

      // Slider fill (visual track)
      if (depositSlider && price > 0) {
        // const pctSlider = (deposit / price) * 100;
        const pctSlider = ((deposit - minprice) / (maxprice - minprice)) * 100;
        depositSlider.style.background =
          `linear-gradient(to right, #fff ${pctSlider}%, var(--fw-border) ${pctSlider}%)`;
      }
    }

    // ---- Toggle ----
    function openWidget() {
      body.hidden = false;
      toggleBtn.classList.add('fw-open');
      header.classList.add('fw-open');
      toggleBtn.setAttribute('aria-expanded', 'true');
    }

    function closeWidget() {
      body.hidden = true;
      toggleBtn.classList.remove('fw-open');
      header.classList.remove('fw-open');
      toggleBtn.setAttribute('aria-expanded', 'false');
    }

    function toggleWidget() {
      if (body.hidden) {
        openWidget();
      } else {
        closeWidget();
      }
    }

    if (header) header.addEventListener('click', toggleWidget);

    // ---- Deposit Input ----
    function syncDeposit(val, trigger) {
      console.log("e.target.value =", val)
      const n = parseFloat(val) || 0;
      currentDeposit = Math.min(Math.max(n, 0), price);

      const deposit  = Math.min(Math.max(currentDeposit, 0), price);
      const financed = price - deposit;
      const monthly  = calcMonthlyPayment(financed, apr, currentTerm);
      const total    = monthly * currentTerm + deposit;
      // Deposit %
      var currentValue = parseInt(depositBadge.getAttribute("data-value"));
      
      const pct = price > 0 ? Math.round((deposit / price) * 100) : 0;
      console.log("pct = ",pct);
      if(currentValue == pct){
        // return false;
      }
      var totalPrice = parseFloat(widget.dataset.price);
      var depositPercents = totalPrice > 0 ? (currentDeposit / totalPrice) * 100 : 0;
      if (depositInput && trigger == "text" )  depositInput.value  = currentDeposit.toFixed(2);
      if (depositSlider && trigger == "range" ) depositSlider.value = parseInt(pct); console.log("updated from above =",parseInt(pct));
      updateUI();
    }

    if (depositInput) {
      depositInput.addEventListener('input', (e) => syncDeposit(e.target.value, "range"));
      depositInput.addEventListener('blur', (e) => syncDeposit(e.target.value, "range"));
    }

    if (depositSlider) {
      // depositSlider.addEventListener('input', (e) => syncDeposit(e.target.value));
      depositSlider.addEventListener('input', (e) => {
        const depositPercent = parseInt(e.target.value);
        const maxAmount = parseFloat(widget.dataset.price);
        const calcAmount = (depositPercent / 100) * maxAmount;
        // depositSlider.setAttribute("value", depositPercent);
        depositSlider.value = depositPercent;
        depositSlider.dispatchEvent(new Event('change', { bubbles: true }));
        console.log("calcAmount = ",calcAmount, " at depositPercent =",depositPercent);
        syncDeposit(calcAmount, "text");
      });
    }

    // ---- Term Buttons ----
    if (termsGrid) {
      termsGrid.addEventListener('click', (e) => {
        const btn = e.target.closest('.fw-term-btn');
        if (!btn) return;
        currentTerm = parseInt(btn.dataset.term, 10);
        console.log("elRepInterest.textContent  = currentAPR + '% P.A. Fixed';  updated =scsc",btn.dataset.interest);
        var currentAPR = btn.dataset.interest;
        if (elRepInterest) {
          elRepInterest.textContent  = currentAPR + '% P.A. Fixed';  
          console.log("elRepInterest.textContent  = currentAPR + '% P.A. Fixed';  updated =",currentAPR);
        }
          
        termsGrid.querySelectorAll('.fw-term-btn').forEach(b => {
          b.classList.toggle('fw-term-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        updateUI();
      });
    }

    // ---- CTA ----
    console.log("ctaBtn >>>>>>>>>= ",ctaBtn);
    
    if (ctaBtn) {
      document.querySelector("#fw-cta-btn").addEventListener('click', () => {
        if (addButton) {
          addButton.click();
        }
        // Add to cart then redirect to checkout
        // if (variantId) {
        //   fetch('/cart/add.js', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({
        //       id: variantId,
        //       quantity: 1,
        //       properties: {
        //         'Finance Term': currentTerm + ' months',
        //         'Finance Deposit': '£' + currentDeposit.toFixed(2),
        //         'Finance APR': apr.toFixed(1) + '%',
        //         '_finance_selected': 'true'
        //       }
        //     })
        //   })
        //   .then(() => { window.location.href = ctaUrl; })
        //   .catch(() => { window.location.href = ctaUrl; });
        // } else {
        //   window.location.href = ctaUrl;
        // }
      });
    }

    // Initial render
    updateUI();
  }

  // ---- Init all widgets on page ----
  function init() {
    document.querySelectorAll('.nomadic-finance-widget').forEach(initFinanceWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on variant change (Shopify theme events)
  document.addEventListener('variant:changed', init);
  document.addEventListener('variantChanged', init);

  const productForm = document.querySelector('.product form[action*="/cart/add"]');
  productForm.addEventListener('change', function(event) {
    if (event.target.name && (event.target.name.includes('options') || event.target.name === 'id')) {
      setTimeout(function() {
        init();
      }, 0);
    }
  });
})();